import store from "../store"
import { userActions } from '../actions/user.actions'
import { userService } from '../_services';
import moment from 'moment'

export function getFreshUser() {
  const t = JSON.parse(localStorage.getItem('user'))
  if (!t) return null
  if (!t.expire) return t
  const e = moment(t.expire).diff(moment(), 'seconds', true)

  if (e < 1) {
    localStorage.removeItem('user');
    //store.dispatch(userActions.refresh(t.refresh)); 
    store.dispatch(userActions.logout());
    return null
  }

  if (e < (t.ttl-60)) userService.refresh(t.refresh)

  return t
}

export function authHeader() {

  const user = getFreshUser()

  if (user && user.access) {
    return {
      "Content-Type": "application/json",
      'Authorization': 'Bearer ' + user.access
    }
  } else {
    return {};
  }
}

export function authHeaderForm() {

  const user = getFreshUser()

  if (user && user.access) {
    return {      
      'Content-Type':'multipart/form-data',
      'Authorization': 'Bearer ' + user.access
    }
  } else {
    return {};
  }
}

export function authUploadHeader() {

  const user = getFreshUser()

  if (user && user.access) {
    return {
      'Authorization': 'Bearer ' + user.access
    }
  } else {
    return {};
  }
}